var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1L2.09346 11.6879C1.74465 12.1064 1.57024 12.3157 1.56758 12.4925C1.56526 12.6461 1.63373 12.7923 1.75326 12.8889C1.89075 13 2.16318 13 2.70803 13H10L9 21L17.9065 10.3121C18.2554 9.89358 18.4298 9.68429 18.4324 9.50754C18.4347 9.35388 18.3663 9.2077 18.2467 9.11111C18.1093 9 17.8368 9 17.292 9H10L11 1Z",
    stroke: "#596173",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergoIcon);
export default __webpack_public_path__ + "static/media/energoIcon.d990fe9eaf94d15586057b02400275c4.svg";
export { ForwardRef as ReactComponent };